import { Search } from 'lucide-react'
import { DebounceInput } from './DebounceInput'

type SearchBarProps = {
    callbackFn: (value: string) => void
    placeholder: string
    debounceTimeoutLength?: number
}

export const DebounceSearchBar: React.FunctionComponent<SearchBarProps> = ({
    callbackFn,
    placeholder,
}) => {
    return (
        <div className="relative mb-4 h-9 w-full max-w-[800px]">
            <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
            <DebounceInput
                value={''}
                placeholder={placeholder}
                callbackFn={(value) => callbackFn(value)}
                className="pl-10"
            />
        </div>
    )
}
